import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-dom-object-type-prop',
  templateUrl: './dom-object-type-prop.component.html',
  styleUrls: ['./dom-object-type-prop.component.css']
})
export class DomObjectTypePropComponent implements OnInit {
    domObjectTypeKeyno;

    public domObjectTypePropKeyno;

    public edit?: Edit;

    public selectListPropertyTypes: PropertyTypeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.domObjectTypeKeyno = this.stateService.getStateParams()['domobjecttype_keyno'];
        this.domObjectTypePropKeyno = this.stateService.getStateParams()['domobjecttypeprop_keyno'];
    }

    private async loadEdit() {
        if (!!this.domObjectTypeKeyno && !!this.domObjectTypePropKeyno) {
            this.edit = (await this.datatask.Post(3022, {
                domobjecttype_keyno: this.domObjectTypeKeyno,
                domobjecttypeprop_keyno: this.domObjectTypePropKeyno
            }))[0];
        }
    }

    private async loadPropertyTypes(): Promise<void> {
        this.selectListPropertyTypes = await this.datatask.Post(3024);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3023, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(3025, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadPropertyTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    domobjecttypeprop_keyno: number;
    domobjecttype_keyno: number;
    domobjecttypeprop_name: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    domobjecttypeproptype_id: string;
    haslanguage: number;
    convert_to_url: number;
    domobjecttypeprop_help: string;
    domobjecttype_name: string;
    orderby: number;
    is_picture_url: number;
}

interface PropertyTypeItem {
    domobjecttypeproptype_id: string;
    domobjecttypeproptype_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectTypeProp', {
//        templateUrl: 'views/components/views/domObjectTypeProp/domObjectTypeProp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'domObjectTypePropService', function ($stateParams, stateService, modalService, translateService, domObjectTypePropService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let domObjectTypeKeyno = $stateParams.domobjecttype_keyno;
//            let domObjectTypePropKeyno = $stateParams.domobjecttypeprop_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                domObjectTypePropKeyno: domObjectTypePropKeyno,
//                edit: {},
//                selectListPropertyTypes: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await domObjectTypePropService.getDomObjectTypeProp({
//                    domobjecttype_keyno: domObjectTypeKeyno,
//                    domobjecttypeprop_keyno: domObjectTypePropKeyno
//                }))[0];
//            }

//            async function loadPropertyTypes() {
//                vm.model.selectListPropertyTypes = await domObjectTypePropService.listPropertyTypes();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                domObjectTypePropService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    domObjectTypePropService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadPropertyTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
